// google direction service with cache

const cache = {};

const googleDirection = (
  directionsService,
  { origin, destination, travelMode }
) =>
  new Promise((resolve, reject) => {
    const originKey = `${origin.lat},${origin.lng}`;
    const destinationKey = `${destination.lat},${destination.lng}`;
    cache[travelMode] = cache[travelMode] || {};
    cache[travelMode][originKey] = cache[travelMode][originKey] || {};

    if (cache[travelMode][originKey][destinationKey]) {
      return resolve(cache[travelMode][originKey][destinationKey]);
    }

    directionsService.route(
      {
        origin,
        destination,
        travelMode
      },
      (response, status) => {
        if (status == 'OK') {
          cache[travelMode][originKey][destinationKey] = response;
          resolve(cache[travelMode][originKey][destinationKey]);
        } else {
          reject(new Error(status));
        }
      }
    );
  });

export default googleDirection;
